import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosAdminPublicInstance from "../../services/axiosAdminPublicInstance";
import * as Endpoints from "../../entities/Endpoints";

// Async thunk to fetch mobile app details
export const fetchMobileAppDetails = createAsyncThunk(
  "onboarding/fetchMobileAppDetails",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axiosAdminPublicInstance.get(
        Endpoints.GET_MOBILE_APP_DETAILS
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Failed to fetch mobile app details"
      );
    }
  }
);

export const fetchCoachOnboardingProcessThunk = createAsyncThunk(
  `${Endpoints.GET_COACH_ONBOARDING_PROCESS}`,
  async ({ offerID }, { rejectWithValue }) => {
    try {
      const response = await axiosAdminPublicInstance.post(
        `${Endpoints.GET_COACH_ONBOARDING_PROCESS}?${offerID}`
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message ||
          "Failed to fetch coach onboarding process"
      );
    }
  }
);

const onboardingSlice = createSlice({
  name: "onboarding",
  initialState: {
    mobileAppDetails: null,
    coachOnboardingProcess: null,
    loading: false,
    loadingOnboardingProcess: false,
    error: null,
    onboardingProcessError: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Mobile App Details cases
      .addCase(fetchMobileAppDetails.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchMobileAppDetails.fulfilled, (state, action) => {
        state.loading = false;
        state.mobileAppDetails = action.payload;
      })
      .addCase(fetchMobileAppDetails.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // Coach Onboarding Process cases
      .addCase(fetchCoachOnboardingProcessThunk.pending, (state) => {
        state.loadingOnboardingProcess = true;
        state.onboardingProcessError = null;
      })
      .addCase(fetchCoachOnboardingProcessThunk.fulfilled, (state, action) => {
        state.loadingOnboardingProcess = false;
        state.coachOnboardingProcess = action.payload;
      })
      .addCase(fetchCoachOnboardingProcessThunk.rejected, (state, action) => {
        state.loadingOnboardingProcess = false;
        state.onboardingProcessError = action.payload;
      });
  },
});

export default onboardingSlice.reducer;
